import { Component, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { Subject } from 'rxjs';
import { AlertService, Dialog } from '../alert.service';
import { APIService } from '../api.service';
import { DataService } from '../data.service';
import { FunctionService } from '../function.service';

@Component({
    selector: 'app-standard-dialog',
    templateUrl: './standard-dialog.component.html',
    styleUrls: ['./standard-dialog.component.css'],
    standalone: false
})
export class StandardDialogComponent implements OnInit {

  dateFormCtrl
  CurrentDialogType = '';
  Announcement = '';

  // @ViewChild('myInput') fileInput: ElementRef;

  constructor(public alertService: AlertService, public DataService: DataService, private APIService: APIService, private FunctionService: FunctionService) { }

  ngOnInit() {
  }

  async OK() {
    await this.alertService.DialogOKPressed();
    this.alertService.currentDialog = null;//this will close the window
  }

  YES() {
    this.alertService.DialogYESPressed();
    this.alertService.currentDialog = null;//this will close the window
    if (this.CurrentDialogType == 'Announcements') {
      this.APIService.SendAnnouncements(this.DataService.SelectedTorn, this.Announcement);
    }
  }

  NO() {
    //this.alertService.DialogNOPressed();
    this.alertService.currentDialog = null;//this will close the window
  }

  // saveTorn(torn) {
  //   this.APIService.updateTorn(torn);
  //   this.alertService.currentDialog = null;
  // }

  alterTornEndDate() {
    //this.DataService.newTorn.endDateOfEvent = this.FunctionService.addHours(36, this.DataService.newTorn.dateOfEvent)
    //this.DataService.newTorn.closingDate = this.FunctionService.addHours(-60, this.DataService.newTorn.dateOfEvent)
  }

  closeDialog() {
    this.alertService.showAnnouncementDialog = false;
    this.alertService.showCreateNewTorn = false;
    this.alertService.showChangeTornDates = false;
    this.alertService.showOKCancel = false;
    this.alertService.showCreateNewDraw = false;
    this.alertService.currentDialog = null;
  }

  // async CreateNewTorn(torn) {
  //   this.DataService.newTorn.id = await this.APIService.createNewTorn(torn);
  //   this.FunctionService.convertTornDates(this.DataService.newTorn)//need to change all dates in new torn to objects....
  //   this.DataService.newTorn.endDateOfEvent = this.FunctionService.addHours(30,this.DataService.newTorn.dateOfEvent);
  //   this.DataService.newTorn.closingDate = this.FunctionService.addHours(-36,this.DataService.newTorn.dateOfEvent);
  //   this.DataService.Torns.unshift(this.DataService.newTorn);
  //   this.alertService.currentDialog = null;
  // }

  async uploadFile(event) {
    var dir;
    var files = event.target.files;
    switch (event.currentTarget.name) {
      case "presetInfoSheet":
        this.DataService.SelectedTorn.presetInfoSheet = "data/" + files[0].name;
        dir = "data";
        break;
      case "posterLocation":
        this.DataService.SelectedTorn.posterLocation = "Posters/" + files[0].name;
        dir = "Posters";
        break;
      case "sponsorImage":
        this.DataService.SelectedTorn.sponsorImage = "images/" + files[0].name;
        dir = "images";
        break;
    }
    await this.APIService.fileUpload(files, dir);
  }

  ConfirmAnnouncement() {
    this.alertService.showAnnouncementDialog = false;
    this.CurrentDialogType = 'Announcements';
    this.alertService.showDialog("Confirm", 'YesNo', null, "Are you sure you want to send an email to all these selected players?", null);
  }

}
